import React from 'react'

const Services = () => {
    return (
        <div>
              {/* <!-- Service section start --> */}
            <div className="service-section content-area-2">
                <div className="container">
                    {/* <!-- Main title --> */}
                    <div className="main-title text-center">
                        <h1>SOMOS LOS MEJORES</h1>
                        <p>Amamos lo que hacemos, por tal motivo TODO lo hacemos bien.</p>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="service-info-2">
                                <div className="icon">
                                    <i className="flaticon-shield"></i>
                                </div>
                                <div className="detail">
                                    <h5>Tramite Seguro</h5>
                                    <p>Nuestras garantias, experiencia y solidez, nos ayuda complementar su servicio de la manmera mas eficaz posible.</p>
                                    <a href="services.html" className="read-more">Leer Mas...</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="service-info-2">
                                <div className="icon">
                                    <i className="flaticon-deal"></i>
                                </div>
                                <div className="detail">
                                    <h5>Agentes Especializados</h5>
                                    <p>Nuestros agentes le ayudaran en todo momento para que su proceso sea mas amigable</p>
                                    <a href="services.html" className="read-more">Leer Mas...</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="service-info-2">
                                <div className="icon">
                                    <i className="flaticon-money"></i>
                                </div>
                                <div className="detail">
                                    <h5>Obten Descuentos</h5>
                                    <p>Se de los afortunados en recibir una de nuestras ofertas de hot sale.</p>
                                    <a href="services.html" className="read-more">Leer Mas...</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="service-info-2">
                                <div className="icon">
                                    <i className="flaticon-support-2"></i>
                                </div>
                                <div className="detail">
                                    <h5>Asesoria GRATIS</h5>
                                    <p>Nuestros asesores te brindara toda la informacion exacta, para que tu tramite sea mas facil.</p>
                                    <a href="services.html" className="read-more">Leer Mas...</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 text-center">
                            <a href="services.html" className="btn btn-theme important-btn">Leer Mas</a>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Service section end --> */}            
        </div>
    )
}


  export default Services



// WEBPACK FOOTER //
// ./src/components/Services.jsx